export interface LoginRequestModel{
    email: string;
    password: string;
}

export interface LoginResponseModel{
    accessToken: string;
    tokenType: string;
    user: UserInfoModel;
    roles: Array<string>;
}

export interface UserInfoModel {
    id: number;
    isActive: boolean;
    title: string;
    fullName: string;
    email: string;
    isFirstLogin: boolean;
    branch: any;
    roles: Array<string>;
    menus: Array<any>;
  customerID: string;
  isCompany1: boolean;
  branchFlag: string;
}

export enum Role {
    Admin = 'Administrator',
    Customer = 'Customer',
    CustomerAdmin = 'Customer Admin'
}

export enum LocalStorageKey {
    Token = 'asapToken',
    CurrentUser = 'currentUser'
}
